import { ImageKit, Typography } from "@aph/ui-lib-humanx";
import React from "react";
import styles from "./PatientProfileInfo.module.scss";

interface PatientProfileInfoProps {
  name?: React.ReactNode;
  mobileNumber?: string;
  uhid?: string;
  imageUrl?: string;
  className?: string;
}

const PatientProfileInfo: React.FC<PatientProfileInfoProps> = (props) => {
  const { name, imageUrl, mobileNumber, uhid, className = "" } = props;

  return (
    <div className={`${styles.patientWrapper} ${className}`}>
      {imageUrl ? (
        <ImageKit src={imageUrl} alt="user profile image" height={48} width={48} className={styles.imgBx} />
      ) : (
        <span className={`icon-user_icon2 ${styles.userIcon}`}>
          <span className="path1"></span>
          <span className="path2"></span>
          <span className="path3"></span>
          <span className="path4"></span>
          <span className="path5"></span>
          <span className="path6"></span>
          <span className="path7"></span>
          <span className="path8"></span>
        </span>
      )}

      <div className={styles.rightBx}>
        {name && <Typography className={styles.title}>{name}</Typography>}
        {mobileNumber && <Typography className={styles.mobileNumber}>{mobileNumber}</Typography>}
        {uhid && <Typography className={styles.uhid}>{uhid}</Typography>}
      </div>
    </div>
  );
};

export default PatientProfileInfo;
